<li class="divider"></li>

<style lang="postcss">
	.divider {
		@apply border-gray-200 border-t my-2;
	}
</style>